const CHATBOT_TYPES = {
  CHATBOT_OPEN: 'CHATBOT_OPEN',
  CHATBOT_CLOSE: 'CHATBOT_CLOSE',
  CHATBOT_TOGGLE: 'CHATBOT_TOGGLE',

  SEND_MESSAGE_REQUEST: 'CHATBOT/SEND_MESSAGE_REQUEST',
  SEND_MESSAGE_SUCCESS: 'CHATBOT/SEND_MESSAGE_SUCCESS',
  SEND_MESSAGE_FAILURE: 'CHATBOT/SEND_MESSAGE_FAILURE',

  APPEND_BOT_TOKEN: 'CHATBOT/APPEND_BOT_TOKEN',
  BOT_TYPING_START: 'CHATBOT/BOT_TYPING_START',
  BOT_TYPING_STOP: 'CHATBOT/BOT_TYPING_STOP',

  CLEAR_HISTORY: 'CHATBOT/CLEAR_HISTORY',

  UPDATE_RATE_LIMIT: 'CHATBOT/UPDATE_RATE_LIMIT',
  RATE_LIMIT_EXCEEDED: 'CHATBOT/RATE_LIMIT_EXCEEDED',
  CHATBOT_DISABLED: 'CHATBOT/CHATBOT_DISABLED',
};

export default CHATBOT_TYPES;
